/** @format */

import { platformResellerConstants } from './actions';
import { notificationConstants } from '../notifications/notifications';
import { reducerDebug } from '../../core/debug';

export function platformResellerReducers(state = {}, action) {
    reducerDebug('PlatformReseller reducer: ' + action.type);
    switch (action.type) {
        case platformResellerConstants.PLATFORM_RESELLER_LIST:
        case platformResellerConstants.PLATFORM_RESSELLER_SELECTED_LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case platformResellerConstants.PLATFORM_RESELLER_ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case platformResellerConstants.PLATFORM_RESELLER_ADD:
        case platformResellerConstants.PLATFORM_RESELLER_EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case platformResellerConstants.PLATFORM_RESELLER_DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
                success: false,
                deletedSuccess: false,
            };
    }
}
